import styled from 'styled-components';

export const StyledLogo = styled.img`
  width: 11.1rem;
  height: 3.4rem;
  cursor: pointer;
`;
